var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneV1FlagForChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 26.875C40 30.6719 37.8919 33.75 33.75 33.75H6.25C2.10813 33.75 0 30.6719 0 26.875V13.125C0 9.32812 2.10813 6.25 6.25 6.25H33.75C37.8919 6.25 40 9.32812 40 13.125V26.875Z",
    fill: "#E41E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1069 10.41L9.44377 13.125L12.4406 13.5593L10.2738 15.6687L10.7844 18.6562L8.1069 17.2468L5.42877 18.6562L5.94002 15.6687L3.77502 13.5593L6.7669 13.125L8.1069 10.41ZM12.8169 8.12122L13.1875 8.87434L14.0213 8.99497L13.4194 9.58184L13.56 10.41L12.8169 10.0187L12.0744 10.41L12.215 9.58184L11.6138 8.99497L12.4456 8.87434L12.8169 8.12122ZM15.2238 10.83L15.595 11.5825L16.425 11.7037L15.8256 12.2918L15.9669 13.1187L15.2238 12.7281L14.4813 13.1187L14.6219 12.2918L14.0213 11.7037L14.8519 11.5825L15.2238 10.83ZM15.2238 15.1775L15.595 15.9318L16.425 16.0525L15.8256 16.6393L15.9669 17.4675L15.2238 17.0775L14.4813 17.4675L14.6219 16.6393L14.0213 16.0525L14.8519 15.9318L15.2238 15.1775ZM12.8169 18.2312L13.1875 18.9843L14.0213 19.1043L13.4194 19.6906L13.56 20.52L12.8169 20.1312L12.0744 20.52L12.215 19.6906L11.6138 19.1043L12.4456 18.9843L12.8169 18.2312Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneV1FlagForChina);
export default __webpack_public_path__ + "static/media/emojione-v1_flag-for-china.133d6e05b48d8c25b02ca721961ed379.svg";
export { ForwardRef as ReactComponent };